import { PILES_TREATMENT_CITIES } from "@/components/PilesTreatmentCityPage";
import { HERNIA_TREATMENT_HTML, herniaTreatmentFaqs } from "@/lib/hernia-treatment-gurgaon-lp";
import type { HerniaCostCity } from "@/lib/hernia-city-lp";

function localizeTreatment(text: string, city: HerniaCostCity): string {
  if (city === "Gurgaon") return text;
  const original = PILES_TREATMENT_CITIES.Gurgaon;
  const local = PILES_TREATMENT_CITIES[city];
  const replacements = [
    [original.doctorImage, local.doctorImage],
    [original.doctorShortQuals, local.doctorShortQuals],
    [original.doctorEducation, local.doctorEducation],
    [original.doctorFellowships, local.doctorFellowships],
    [original.address, local.address],
    [original.addressShort, local.addressShort],
    [original.mapUrl.replaceAll("&", "&amp;"), local.mapUrl.replaceAll("&", "&amp;")],
    ["on Sohna Road in Sector 68", `at ${local.addressShort}`],
    ["Dr. N. K. Mandal", local.doctor],
    ["Senior General &amp; Laparoscopic Surgeon", local.doctorRole.replaceAll("&", "&amp;")],
    ["https://healic.in/gurgaon/hernia-treatment", `https://healic.in/${city === "Muzaffarnagar" ? city : local.slug}/hernia-treatment`],
  ];
  return replacements.reduce((html, [from, to]) => html.replaceAll(from, to), text)
    .replaceAll("Gurgaon", city).replaceAll("Gurugram", city)
    .replaceAll("Healic+Gurgaon", `Healic+${city}`);
}

export function herniaTreatmentHtml(city: HerniaCostCity): string {
  return localizeTreatment(HERNIA_TREATMENT_HTML, city);
}

export function herniaTreatmentCityFaqs(city: HerniaCostCity) {
  return herniaTreatmentFaqs.map(({ q, a }) => ({ q: localizeTreatment(q, city), a: localizeTreatment(a, city) }));
}